var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09999 10.8169L10.5333 1.40022C10.6883 1.24401 10.8726 1.12002 11.0757 1.03541C11.2788 0.950791 11.4966 0.907227 11.7167 0.907227C11.9367 0.907227 12.1545 0.950791 12.3576 1.03541C12.5607 1.12002 12.7451 1.24401 12.9 1.40022C13.2104 1.71249 13.3846 2.13491 13.3846 2.57522C13.3846 3.01553 13.2104 3.43795 12.9 3.75022L4.64999 12.0836L12.9 20.3336C13.2104 20.6458 13.3846 21.0682 13.3846 21.5086C13.3846 21.9489 13.2104 22.3713 12.9 22.6836C12.7456 22.841 12.5616 22.9663 12.3584 23.0521C12.1553 23.138 11.9372 23.1826 11.7167 23.1836C11.4961 23.1826 11.278 23.138 11.0749 23.0521C10.8718 22.9663 10.6877 22.841 10.5333 22.6836L1.09999 13.2669C0.930814 13.1108 0.7958 12.9214 0.703454 12.7106C0.611109 12.4997 0.563435 12.2721 0.563435 12.0419C0.563435 11.8117 0.611109 11.584 0.703454 11.3732C0.7958 11.1624 0.930814 10.973 1.09999 10.8169Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.455fdc344490b3005e6f400ebde46992.svg";
export { ForwardRef as ReactComponent };